import type {
  DocumentType,
  OrderItemType,
  OrderItemsBlockType,
} from '@src/types';

export type { OrderItemType, DocumentType } from '@src/types';

export enum OrderActionTypes {
  SetOrder = 'ORDER/SET_ORDER',
  SetOrderSubmitData = 'ORDER/SE_SET_ORDER_SUBMIT_DATA',
  SetOrderInitData = 'ORDER/SE_SET_ORDER_INIT_DATA',
  SetOrderPageTitle = 'ORDER/SET_ORDER_PAGE_TITLE',
  SetOrderRequestData = 'ORDER/SET_ORDER_REQUEST_DATA',
  SetCachedOrderRequestData = 'ORDER/SET_CACHED_REQUEST_DATA',
  SetThemeValue = 'ORDER/SET_THEME_VALUE',
  SetSubscriptionId = 'ORDER/SET_SUBSCRIPTION_ID',
  SetCompletePaymentData = 'ORDER/SET_COMPLETE_PAYMENT_DATA',
  SetHasSpecialOffersConsent = 'ORDER/SET_HAS_SPECIAL_OFFERS_CONSENT',
}

export type OrderDataTypes = OrderItemType[] | OrderItemsBlockType[];

export type OrderSubmitDataTypes = {
  contractId: string;
  address: string;
  clientDocument: DocumentType[];
  premiumAndDelta: string | number;
  billId: string;
  subscriptionId: string;
  subscriptionNumber: string;
  contractNumber: string;
  orderNumber: string;
  subscriptionType: string;
  isSuccessfulPromo?: null | boolean;
  premiumAndDeltaBeforePromo?: number;
};

export type OrderInitDataTypes = {
  id: string;
  signature: string;
  clientCoreId: string;
  paymentGateOrder: string;
  sector: string;
  url: string;
  failUrl: string;
  paymentInstruments: string[] | [];
};
